import { render, staticRenderFns } from "./purchase-ticket.vue?vue&type=template&id=7665c412&scoped=true&"
import script from "./purchase-ticket.vue?vue&type=script&lang=js&"
export * from "./purchase-ticket.vue?vue&type=script&lang=js&"
import style0 from "./purchase-ticket.vue?vue&type=style&index=0&id=7665c412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7665c412",
  null
  
)

export default component.exports